import { request } from './http';

export async function getQiNotificationLogs() {
    return request('/testing/qi-notification-logs');
  }

export async function getQiNotificationLog(id) {
    return request(`/testing/qi-notification-logs/${id}`);
  }

export async function createQiNotificationLog(data) {
    return request('/testing/qi-notification-logs', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateQiNotificationLog(id, data) {
    return request(`/testing/qi-notification-logs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function generateQiNotificationLogPdf(recordId, recipientEmail, options = {}) {
    return request('/pdf/generate-qi-notification-log', {
      method: 'POST',
      body: JSON.stringify({ recordId, recipientEmail, ...options }),
    });
  }

export async function getQiNotificationLogAttachments(id) {
    return request(`/testing/qi-notification-logs/${id}/attachments`);
  }

export async function addQiNotificationLogAttachment(id, data) {
    return request(`/testing/qi-notification-logs/${id}/attachments`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteQiNotificationLogAttachment(id, attachmentId) {
    return request(`/testing/qi-notification-logs/${id}/attachments/${attachmentId}`, {
      method: 'DELETE',
    });
  }

export async function getQiNotificationLogLinks(id) {
    return request(`/testing/qi-notification-logs/${id}/links`);
  }

export async function addQiNotificationLogLink(id, data) {
    return request(`/testing/qi-notification-logs/${id}/links`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteQiNotificationLogLink(id, linkId) {
    return request(`/testing/qi-notification-logs/${id}/links/${linkId}`, {
      method: 'DELETE',
    });
  }

export async function getEquipmentDeploymentLogs() {
    return request('/testing/equipment-deployment-logs');
  }

export async function getEquipmentDeploymentLog(id) {
    return request(`/testing/equipment-deployment-logs/${id}`);
  }

export async function createEquipmentDeploymentLog(data) {
    return request('/testing/equipment-deployment-logs', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateEquipmentDeploymentLog(id, data) {
    return request(`/testing/equipment-deployment-logs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteEquipmentDeploymentLog(id) {
    return request(`/testing/equipment-deployment-logs/${id}`, {
      method: 'DELETE',
    });
  }

export async function generateEquipmentDeploymentLogPdf(recordId, recipientEmail, options = {}) {
    return request('/pdf/generate-equipment-deployment-log', {
      method: 'POST',
      body: JSON.stringify({ recordId, recipientEmail, ...options }),
    });
  }

export async function getEquipmentDeploymentLogAttachments(id) {
    return request(`/testing/equipment-deployment-logs/${id}/attachments`);
  }

export async function addEquipmentDeploymentLogAttachment(id, data) {
    return request(`/testing/equipment-deployment-logs/${id}/attachments`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteEquipmentDeploymentLogAttachment(id, attachmentId) {
    return request(`/testing/equipment-deployment-logs/${id}/attachments/${attachmentId}`, {
      method: 'DELETE',
    });
  }

export async function getEquipmentDeploymentLogLinks(id) {
    return request(`/testing/equipment-deployment-logs/${id}/links`);
  }

export async function addEquipmentDeploymentLogLink(id, data) {
    return request(`/testing/equipment-deployment-logs/${id}/links`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteEquipmentDeploymentLogLink(id, linkId) {
    return request(`/testing/equipment-deployment-logs/${id}/links/${linkId}`, {
      method: 'DELETE',
    });
  }

export async function getTabletopLogs() {
    return request('/testing/annual-tabletop-logs');
  }

export async function getTabletopLog(id) {
    return request(`/testing/annual-tabletop-logs/${id}`);
  }

export async function generateTabletopExerciseLogPdf(recordId, recipientEmail, options = {}) {
    const payload = { recordId, ...options };
    if (recipientEmail !== undefined && recipientEmail !== null && recipientEmail !== '') {
      payload.recipientEmail = recipientEmail;
    }
    return request('/pdf/generate-and-save-tabletop-exercise-log', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

export async function createTabletopLog(data) {
    return request('/testing/annual-tabletop-logs', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateTabletopLog(id, data) {
    return request(`/testing/annual-tabletop-logs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteTabletopLog(id) {
    return request(`/testing/annual-tabletop-logs/${id}`, {
      method: 'DELETE',
    });
  }

export async function getTabletopLogAttachments(id) {
    return request(`/testing/annual-tabletop-logs/${id}/attachments`);
  }

export async function addTabletopLogAttachment(id, data) {
    return request(`/testing/annual-tabletop-logs/${id}/attachments`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteTabletopLogAttachment(id, attachmentId) {
    return request(`/testing/annual-tabletop-logs/${id}/attachments/${attachmentId}`, {
      method: 'DELETE',
    });
  }

export async function getTabletopLogLinks(id) {
    return request(`/testing/annual-tabletop-logs/${id}/links`);
  }

export async function addTabletopLogLink(id, data) {
    return request(`/testing/annual-tabletop-logs/${id}/links`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteTabletopLogLink(id, linkId) {
    return request(`/testing/annual-tabletop-logs/${id}/links/${linkId}`, {
      method: 'DELETE',
    });
  }

export const testingEnvironmentalSamplingApi = {
  getQiNotificationLogs,
  getQiNotificationLog,
  createQiNotificationLog,
  updateQiNotificationLog,
  generateQiNotificationLogPdf,
  getQiNotificationLogAttachments,
  addQiNotificationLogAttachment,
  deleteQiNotificationLogAttachment,
  getQiNotificationLogLinks,
  addQiNotificationLogLink,
  deleteQiNotificationLogLink,
  getEquipmentDeploymentLogs,
  getEquipmentDeploymentLog,
  createEquipmentDeploymentLog,
  updateEquipmentDeploymentLog,
  deleteEquipmentDeploymentLog,
  generateEquipmentDeploymentLogPdf,
  getEquipmentDeploymentLogAttachments,
  addEquipmentDeploymentLogAttachment,
  deleteEquipmentDeploymentLogAttachment,
  getEquipmentDeploymentLogLinks,
  addEquipmentDeploymentLogLink,
  deleteEquipmentDeploymentLogLink,
  getTabletopLogs,
  getTabletopLog,
  generateTabletopExerciseLogPdf,
  createTabletopLog,
  updateTabletopLog,
  deleteTabletopLog,
  getTabletopLogAttachments,
  addTabletopLogAttachment,
  deleteTabletopLogAttachment,
  getTabletopLogLinks,
  addTabletopLogLink,
  deleteTabletopLogLink,
};

